export class ModelosTrabalho {
    static homeoffice = "Home Office";
    static hibrido = "Híbrido";
    static presencial = "Presencial";
}